/**
 * Route for `igaming-gdpr-regional-data-residency-for-igaming-t`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingGdprRegionalDataResidencyForIgamingTPage } from "../features/igaming-gdpr-regional-data-residency-for-igaming-t/IgamingGdprRegionalDataResidencyForIgamingTPage";

export const igamingGdprRegionalDataResidencyForIgamingTRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-gdpr-regional-data-residency-for-igaming-t",
	component: IgamingGdprRegionalDataResidencyForIgamingTPage,
});

export default igamingGdprRegionalDataResidencyForIgamingTRoute;
